import { render } from "./CartButton.vue?vue&type=template&id=53106064&scoped=true"
import script from "./CartButton.vue?vue&type=script&lang=js"
export * from "./CartButton.vue?vue&type=script&lang=js"

import "./CartButton.vue?vue&type=style&index=0&id=53106064&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53106064"]])

export default __exports__